export default () => ({
  agenda_id: null,
  agenda: {
    address: {},
    schedules: []
  }
})



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/active-agenda/resources/data.js